export default "__VITE_ASSET__C08H_jJX__"